<!--suppress JSIgnoredPromiseFromCall -->
<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      append-to-body
    >
      <el-form
        :model="form"
        :rules="rules"
        class="font-weight-bold"
        label-width="80px"
        ref="passwordForm"
      >
        <el-form-item label="用户名">
          {{ this.$store.state.user.username }}
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            auto-complete="off"
            placeholder="请输入新密码 6-20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="form.confirmPassword"
            auto-complete="off"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitPasswordForm(form, 'passwordForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <a class="navbar-brand" href="#"
      ><!--suppress CheckImageSize -->
      <img src="../../assets/logo.png" alt="logo" width="40" class="mr-3" />
      万匠游戏后台管理
      <!--<el-link-->
      <!--:underline="false"-->
      <!--class="el-icon-s-fold ml-1"-->
      <!--@click="toggleMenuCollapse"-->
      <!--&gt;-->
      <!--</el-link>-->
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="ml-auto mr-3">
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ this.$store.state.user.nickname }}
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="text-center">
          <el-dropdown-item>
            <a @click="dialogFormVisible = true"
              ><i class="el-icon-lock el-icon--right font-weight-bold"></i
              >修改密码</a
            >
          </el-dropdown-item>
          <el-dropdown-item divided>
            <a @click="logout">
              <i
                class="el-icon-switch-button el-icon--right font-weight-bold"
              ></i>
              登出
            </a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </nav>
</template>

<script>
import { createRouter } from "../../router";

export default {
  name: "AdminHeader",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "请输入6-20位字符", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur", required: true }
        ]
      },
      form: {
        password: "",
        confirmPassword: ""
      }
    };
  },
  methods: {
    logout() {
      const _this = this;
      this.axios.get("/login/logout").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          _this.$store.commit("logout");
          _this.$router.replace("/login");
          // 清空路由，防止路由重复加载
          const newRouter = createRouter();
          _this.$router.matcher = newRouter.matcher;
        }
      });
    },
    submitPasswordForm(form, formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.axios
            .post("/adminUser/updatePassword", {
              userId: this.$store.state.user.userId,
              password: form.password
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.dialogFormVisible = false;
                this.logout();
                this.$notify({
                  title: "成功",
                  message: "密码修改成功，请重新登录",
                  type: "success"
                });
              } else {
                this.$notify.error({
                  title: "错误",
                  message: "添加失败！"
                });
              }
            });
        } else {
          return false;
        }
      });
    }
    // toggleMenuCollapse() {
    //   this.$store.commit("toggleMenuIsCollapse");
    // }
  }
};
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
